/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetMultipleTransferOrders_Out } from '../models/GetMultipleTransferOrders_Out';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferOrdersService {

    /**
     * Get Transfer Order
     * Get the transfer order as file
     * @param transferOrderId The id of the transfer order to get
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getTransferOrder(
        transferOrderId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/transfer-orders/{transfer_order_id}/file',
            path: {
                'transfer_order_id': transferOrderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Transfer Orders
     * Get all transfer orders sorted by date
     * @returns GetMultipleTransferOrders_Out Successful Response
     * @throws ApiError
     */
    public static getAllTransferOrders(): CancelablePromise<GetMultipleTransferOrders_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/transfer-orders/',
        });
    }

}